import React from "react";
import * as dt from '../../helpers/dateTime';
import { formatPrice } from '../../helpers/formatting';
import * as types from "../../constants/actionTypes";
import { Link } from "react-router-dom";
import { logUI } from "../../api/andyliticsApi";

const Appointment = props => {
    //console.info('Appointment props', props);
    
    const now = new Date();
    const aptDate = new Date(props.appointment.dateOfService);
    const hidden = (props.appointment.quoteAmount === '' || props.appointment.quoteAmount === "99999.99" || props.appointment.dateOfService === "")?'hidden':props.past ? aptDate < now ? '' : 'hidden' : aptDate >= now ? '' : 'hidden';



    try {
        return <div key={props.appointment.csnId} className={`row my-estimates-estimate ${hidden}`}>
            <div onClick={() => { logUI("MBHWeb.UI.MyEstimates.appointment", new Date(), window.location.href, props.appointment, 'myEstimates', 'link clicked');}} className="col-12">
                <div className="card my-estimates-estimate-tile">
                    <Link to={`/estimates/estimateDetails/${props.appointment.csnId}`}>
                        <div className="card-header">
                            <div className="row">
                                <div className="col-8">
                                    <div className="card-heading">{props.appointment.quoteName ? props.appointment.quoteName : 'Appointment'}</div>
                                    <div className="row appt-names">
                                        <div className="col patient">PATIENT: {`${props.appointment.firstName} ${props.appointment.lastName}`}</div>
                                        {shouldDisplayProviderName(props.appointment) && <div className={`col provider`}>PROVIDER: {props.appointment.providerInformation.name}</div>}
                                    </div>
                                </div>
                                <div className="col-4 appt-date">
                                    <div className="row appt-date--heading">
                                        <div className="col">{dt.formatDate(props.appointment.dateOfService, { month: 'short', day: 'numeric' }).toUpperCase()}</div>
                                    </div>
                                    <div className="row appt-date--subheading">
                                        <div className="col">{dt.formatTime(props.appointment.dateOfService, { hour: 'numeric', minute: '2-digit' })}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12 location">{(props.appointment.providerInformation && props.appointment.providerInformation.location)?props.appointment.providerInformation.location:props.appointment.facilityName}</div>
                                <div className="col-12">
                                    <div className="cost"><h4>Out of Pocket Estimate: <span className="price">{formatPrice(props.appointment.quoteAmount)}</span></h4></div>
                                    <div className="created">Estimate created on {dt.formatDate(props.appointment.dateOfEstimate, { month: "long", day: "2-digit", year: "numeric" })}</div>
                                </div>
                            </div>
                        </div>
                    </Link>
                 </div>
            </div>
        </div>;
    } catch (ex) {
        //console.error(`appointment exception`,ex);
        logUI("MBHWeb.UI.Estimates.appointment", new Date(), `myEstimates/`, props, 'ERROR', ex.message); 
        return <React.Fragment>{ ex}</React.Fragment>;
    }

}

const shouldDisplayProviderName = (apt) => {
    return hasName(apt) && isNotAHospital(apt);
}
const hasName = (apt) => {
    const isAName = apt.providerInformation
        && apt.providerInformation.name
        && apt.providerInformation.name !== "";
    return isAName;
}
const isNotAHospital = (apt) => {
    const isNAH = apt.providerInformation.environment.toUpperCase().indexOf('HOSPITAL') === -1;
    return isNAH;
}

export default Appointment;